<template>
  <div>
    <div class="search-title">
      <van-cell-group>
        <van-cell :title="title">
          <template #icon>
            <van-icon class="search-history-icon" size="0.5rem" :name="$getImgUrl(iconUrl)">
            </van-icon>
          </template>
          <template #default>
            <p class="history-clear-button" @click="clear">{{ value }}</p>
          </template>
        </van-cell>
      </van-cell-group>
    </div>
    <van-row class="search-list">
      <van-col span="12" class="search-item" :style="{ 'color': fontColor, 'border-color': borderColor }"
        v-for="(item,index) in list" :key="index" @click="toSearchItem(item)">
        <div >{{ item }}</div>
      </van-col>
    </van-row>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    list: {
      type: Array,
      default: () => {
        return []
      }
    },
    borderColor: {
      type: String,
      default: '#117281'
    },
    fontColor: {
      type: String,
      default: '#999'
    },
    iconUrl: {
      type: String,
      default: ''
    },
    rightButton: {
      type: Function,
      default: null
    }
  },
  data () {
    return {}
  },
  computed: {},
  methods: {
    clear () {
      this.rightButton.apply()
    },
    toSearchItem (item) {
      this.$store.commit('search_m_setKeywordData', item)
      this.$emit('clickItem', item)
    }
  }
}
</script>
<style scoped lang="less">
.search-list {
  padding: 0.4rem;

  .search-item {
    font-size: 0.35rem;
    color: #999;
    display: inline-block;
    margin-bottom: 0.2rem;
    padding-left: 0.1rem;
    border-left: 2px solid #117281;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.van-cell {
  font-size: 0.35rem;

}

.van-cell::after {
  position: absolute;
  box-sizing: border-box;
  content: ' ';
  pointer-events: none;
  right: 16px;
  bottom: 0;
  left: 16px;
  border-bottom: 1px solid #ebedf0;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
}

.search-title {
  // display: flex;
  // align-items: center;
  // justify-content: space-between;

  .search-history-icon {
    margin-right: 0.2rem;
  }

  .history-clear-button {
    color: var(--base-green);
  }
}
</style>
